// Laguna Benefits — analytics helper (Phase 1).
// Per spec: single file, console.log only, no external calls. Frontend uses
// this on every form submission and key UI interaction.

export function track(eventName, properties = {}) {
    try {
        // eslint-disable-next-line no-console
        console.log("[track]", eventName, properties);
    } catch (_) {
        // Never let analytics break the UI.
    }
}
